export default __webpack_public_path__ + "static/media/ico-close.edcaaac8.svg";